const loadTheme = require('../theme-loader');
const theme = loadTheme();
export default theme;
